import { Box } from "@mantine/core";

function ScreenshotsSection() {
  return (
    <Box mb="md">

    </Box>
  );
}

export default ScreenshotsSection;
